import { Menu } from 'antd';
import styled from 'styled-components';

export const SectionNavContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 16px;
`;

export const StyledSectionNav = styled(Menu)`
  border-inline-end: none !important;
  background: transparent;

  &.ant-menu-inline {
    width: 100%;
  }

  /* Base item */
  & .ant-menu-item,
  & .ant-menu-submenu-title {
    height: 44px;
    line-height: 44px;
    border-radius: 8px;
    margin-inline: 0 !important;
    margin-block: 4px !important;
    padding-inline: 16px !important;
    padding-right: 34px !important; /* leave room for submenu chevron */
    font-size: 16px;
    color: rgba(55, 65, 81, 1);
    font-weight: 500;
  }

  /* Active leaf item highlight (matches 1st screenshot) */
  & .ant-menu-item.ant-menu-item-selected {
    background-color: #f3fffc !important;
    color: rgba(17, 24, 39, 1) !important;
    position: relative;
  }

  & .ant-menu-item.ant-menu-item-selected::before {
    content: '';
    position: absolute;
    left: 0;
    top: 8px;
    bottom: 8px;
    width: 3px;
    border-radius: 2px;
    background: rgba(16, 185, 129, 1);
  }

  /* Hover */
  & .ant-menu-item:not(.ant-menu-item-selected):hover,
  & .ant-menu-submenu-title:hover {
    background: rgba(243, 255, 252, 0.6);
  }

  /* Submenu title layout (label + badge + chevron) */
  & .section-nav-submenu-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 10px;
  }

  /* Ensure badge doesn't overlap the submenu arrow */
  & .ant-menu-submenu-title .ant-menu-submenu-arrow {
    inset-inline-end: 14px;
  }

  & .section-nav-submenu-title .section-nav-submenu-left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  & .section-nav-submenu-title .section-nav-submenu-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* Badge styling (matches 2nd screenshot) */
  & .section-nav-submenu-title .ant-badge {
    flex: none;
  }

  & .section-nav-submenu-title .ant-badge-count {
    box-shadow: none;
    background: rgba(243, 244, 246, 1);
    color: rgba(17, 24, 39, 1);
    font-weight: 600;
    min-width: 20px;
    height: 20px;
    line-height: 20px;
    padding: 0 6px;
  }

  /* Expanded submenu children indent and guide line (matches 2nd screenshot) */
  & .ant-menu-sub.ant-menu-inline {
    background: transparent;
    margin-left: 12px;
    padding-left: 12px;
    position: relative;
  }

  & .ant-menu-sub.ant-menu-inline::before {
    content: '';
    position: absolute;
    left: 0;
    top: 10px;
    bottom: 10px;
    width: 2px;
    border-radius: 2px;
    background: rgba(229, 231, 235, 1);
  }

  & .ant-menu-sub.ant-menu-inline > .ant-menu-item {
    height: 36px;
    line-height: 36px;
    padding-inline: 12px !important;
    font-weight: 500;
  }

  /* Keep submenu title readable when open */
  & .ant-menu-submenu-open > .ant-menu-submenu-title {
    background: rgba(243, 244, 246, 0.8);
  }

  /* Remove default selected bar */
  &.ant-menu-inline .ant-menu-item::after {
    display: none;
  }
`;
